import styles from "./SupplierForm.module.scss";
import primaryComponents from "../../primaryComponents";
import useSupplierForm from "./useSupplierForm";
import Validation from "./Validation";

const SupplierForm = ({
  supplierInfo = null,
  isEditMode = false,
  handleFetchSuppliers = () => {},
  closeWidget = () => {},
}) => {
  const {
    isAddingSupplier,
    isEditingSupplier,
    supplierDetails,
    storeList,
    // has_consent_to_contact_suppliers,
    setSupplierDetails,
    submitSupplierInfo,
  } = useSupplierForm({
    supplierInfo,
    isEditMode,
    handleFetchSuppliers,
    closeWidget,
  });
  const {
    handleSubmit,
    control,
    register,
    trigger,
    formState: { errors },
  } = Validation({ supplierDetails });

  return (
    <div className={styles.supplierForm}>
      {/* form section */}
      <form className={styles.formSection}>
        <primaryComponents.InputFieldV2
          control={control}
          classNames="white"
          name="email"
          label="Email"
          placeholder="Enter enter email"
          value={supplierDetails?.email}
          onChange={({ target: { value } }) => {
            setSupplierDetails((prev) => ({
              ...prev,
              email: value,
            }));
          }}
          errorMessage={errors.email}
          onKeyUp={() => errors.email !== undefined && trigger("email")}
          register={register}
        />

        <primaryComponents.InputFieldV2
          control={control}
          classNames="white"
          name="supplierName"
          label="Supplier Name"
          placeholder="Enter your supplier name"
          isRequired={true}
          value={supplierDetails.name}
          onChange={({ target: { value } }) => {
            console.log(7774);
            setSupplierDetails((prev) => ({
              ...prev,
              name: value,
            }));
          }}
          errorMessage={errors.supplierName}
          onKeyUp={() =>
            errors.supplierName !== undefined && trigger("supplierName")
          }
          register={register}
        />

        <primaryComponents.MultipleSelectFieldV2
          control={control}
          name="stores"
          label="Stores"
          placeholder="Select stores..."
          options={storeList}
          idKey="id"
          nameKey="name"
          value={storeList
            ?.filter((store) => supplierDetails?.stores?.includes(store?.id))
            ?.map((store) => ({ value: store?.id, label: store?.name }))}
          onChange={(values) => {
            setSupplierDetails((prev) => ({
              ...prev,
              stores: values?.map((store) => store?.value) || [],
            }));
          }}
          errorMessage={errors.stores}
        />

        <primaryComponents.InputFieldV2
          control={control}
          isRequired={true}
          classNames="white"
          name="supplierContactName"
          label="Supplier Contact Name"
          placeholder="Enter supplier contact name"
          value={supplierDetails?.contact_name}
          onChange={({ target: { value } }) => {
            setSupplierDetails((prev) => ({
              ...prev,
              contact_name: value,
            }));
          }}
          errorMessage={errors.supplierContactName}
          onKeyUp={() =>
            errors.supplierContactName !== undefined &&
            trigger("supplierContactName")
          }
          register={register}
        />

        <primaryComponents.PhoneNumberInputFieldV2
          control={control}
          classNames="white"
          name="supplierPhone"
          label="Supplier Phone Number"
          placeholder="Enter your supplier phone number"
          isRequired={true}
          value={supplierDetails.phone_number}
          onChange={({ target: { value } }) => {
            setSupplierDetails((prev) => ({
              ...prev,
              phone_number: value,
            }));
          }}
          errorMessage={errors.supplierPhone}
          onKeyUp={() =>
            errors.supplierPhone !== undefined && trigger("supplierPhone")
          }
          register={register}
          phoneCodeEditable={true}
          onChangePhoneCode={(val) => {
            setSupplierDetails((prev) => ({
              ...prev,
              phone_code: val,
            }));
          }}
          countryCode={supplierDetails.phone_code}
        />

        <primaryComponents.InputFieldV2
          control={control}
          isRequired={true}
          classNames="white"
          name="supplierAddress"
          label="Supplier Address"
          placeholder="Enter supplier address"
          value={supplierDetails?.address}
          onChange={({ target: { value } }) => {
            setSupplierDetails((prev) => ({
              ...prev,
              address: value,
            }));
          }}
          errorMessage={errors.supplierAddress}
          onKeyUp={() =>
            errors.supplierAddress !== undefined && trigger("supplierAddress")
          }
          register={register}
        />

        {!isEditMode && (
          <div>
            <primaryComponents.AmountFieldV2
              control={control}
              classNames="white"
              name="openingBalance"
              label="Opening Balance"
              placeholder="Enter any pre-existing debt or credit"
              value={supplierDetails?.opening_balance}
              onChange={({ target: { value } }) => {
                setSupplierDetails((prev) => ({
                  ...prev,
                  opening_balance: value,
                }));
              }}
              errorMessage={errors.openingBalance}
              onKeyUp={() =>
                errors.openingBalance !== undefined && trigger("openingBalance")
              }
              register={register}
              floatError={false}
            />
            <p className="small-text-size gray--text">
              Positive amount means you owe the supplier.
            </p>
          </div>
        )}

        {/* {!has_consent_to_contact_suppliers ? (
          <div className="d-flex align-items-center mb-2">
            <primaryComponents.Checkbox
              name={"isConsentLumiToContact"}
              id={"isConsentLumiToContact"}
              isChecked={supplierDetails?.has_consent_lumi_to_contact}
              onChange={() =>
                setSupplierDetails((prev) => ({
                  ...prev,
                  has_consent_lumi_to_contact:
                    !supplierDetails?.has_consent_lumi_to_contact,
                }))
              }
            />
            <label
              htmlFor="isEnabledOnCheckout"
              className="mt-1 cursor-pointer"
            >
              Consent to Lumi contacting your suppliers
            </label>
          </div>
        ) : null} */}

        <primaryComponents.Button
          classNames={"btn btn--primary cover mt-4"}
          isLoading={isEditMode ? isEditingSupplier : isAddingSupplier}
          isDisabled={isEditMode ? isEditingSupplier : isAddingSupplier}
          loadingText={isEditMode ? "Updating..." : "Adding..."}
          type="button"
          onClick={handleSubmit(submitSupplierInfo)}
        >
          {isEditMode ? "Update" : "Add Supplier"}
        </primaryComponents.Button>
      </form>
    </div>
  );
};
export default SupplierForm;
